export default "__VITE_ASSET__C0VJ_Lrh__"